import styled from 'styled-components';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { onMobile } from '../../common/styles/onMobile';
import { responsiveInterpolate } from '../../common/styles/responsiveInterpolate';
import { Container, PillRow, TextDescription } from '../FilterContainer/FilterContainer.styles';
import { CrossIcon } from '../FilterContainer/FilterPill/FilterPill.styles';

export const ProviderContainer = styled(Container)`
  background-color: ${ThemeColours.primary600};
  color: ${ThemeColours.white};
  height: 56px;
  margin-top: ${responsiveInterpolate(52, 72)};

  ${onMobile} {
    height: 156px;
    padding: 5px;
  }
`;

export const ProviderPillRow = styled(PillRow)`
  ${onMobile} {
    flex-wrap: wrap;
    padding: 5px;
  }
`;

export const Text = styled(TextDescription)`
  ${onMobile} {
    margin: 0 auto;
  }
`;

export const CloseIcon = styled(CrossIcon)`
  margin-inline-start: 0;
`;

export const ProviderRow = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;
